module.exports = __webpack_public_path__ + "img/help_card_02.ee5af7c3.png";